export default __webpack_public_path__ + "static/media/my_pic.95789985.jpg";